export default __webpack_public_path__ + "static/media/anti-slip_sage_green.8f45fd76.webp";